// extracted by mini-css-extract-plugin
export default {"container":"create-or-edit-modal_container__I65jN","button-container":"create-or-edit-modal_button-container__CYc94","loading":"create-or-edit-modal_loading__1Acjj"};